import { Button } from '@accure/ui';
import { PlusIcon } from 'lucide-react';

import { useAddWorkstreamModal } from '@/project-management/modals/add-workstream';

export function AddWorkstreamButton() {
  const showAddWorkstreamModal = useAddWorkstreamModal();

  return (
    <Button onClick={() => showAddWorkstreamModal('custom')}>
      <PlusIcon className="size-4" />
      Add Workstream
    </Button>
  );
}
